import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const words = ["Powering Professionals", "Built to Last", "Precision", "Power", "Performance"];
  return (
    <div className="relative border-y border-white/5 bg-[#0a0a0a] py-6 overflow-hidden" data-testid="marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.25)] px-8">
              {w}
            </span>
            <span className="text-orange-500 text-3xl md:text-5xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
